
let singleton = null;
let singletonEnforcer = 'singletonEnforcer';

class CommonNctv {

    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) throw "Cannot--construct singleton";
    }

    static get instance() {
        if (!singleton) singleton = new CommonNctv(singletonEnforcer);
        return singleton;
    }

    init(){
        this.isMobileDe = (/(iPhone|iPod|iPad|Android|NC Noob)/i.test(navigator.userAgent));

        this.__env = location.href.match(/(rc\.|rc\-)/i)? location.href.match(/(rc\.|rc\-)/i)[1]: 'live';
        this.__env = (/opdev\./i.test(location.href))? 'opdev': this.__env;
        this.__env = (/local\.|localhost|ui-static\.|file:/i.test(location.href))? 'local': this.__env;

        this._staticPath = 'https://wstatic-cdn.plaync.com/nctv/v1';
        if(typeof window.nctvConfig === "object"){
            this._staticPath = nctvConfig.staticPath;
            this._apiDomain = nctvConfig.apiDomain;
        }

        this._ip = this.getParamByName('tv');
        this._id = this.getParamByName('id');
        this._from = this.getParamByName('from');
    }

    get isMobile(){
        return this.isMobileDe;
    }

    get env(){
        return this.__env;
    }

    get ip(){
        return this._ip;
    }

    get id(){
        return this._id;
    }

    get from(){
        return this._from;
    }

    get staticPath(){
        return this._staticPath;
    }

    get apiDomain(){
        return this._apiDomain;
    }

    getParamByName( name, url ) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }



}

export default CommonNctv;